"use client";

import { motion, useReducedMotion } from "framer-motion";
import { Zap, Globe, Lock } from "lucide-react";
export default function Partnerbenefitsgrid() {
  const shouldReduceMotion = useReducedMotion();
  const perks = [{
    icon: Zap,
    title: "ULTRA-FAST SPEEDS",
    description: "Experience lightning-fast connection speeds optimized for streaming, gaming, and heavy downloads without any throttling or buffering."
  }, {
    icon: Globe,
    title: "GLOBAL SERVER NETWORK",
    description: "Access content from anywhere in the world with our massive network of high-performance servers located in over 100 countries."
  }, {
    icon: Lock,
    title: "MILITARY-GRADE SECURITY",
    description: "Protect your digital footprint with advanced encryption protocols designed to keep your personal data private and secure at all times."
  }];
  const containerVariants = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: shouldReduceMotion ? 0 : 0.1
      }
    }
  };
  const cardVariants = {
    hidden: shouldReduceMotion ? {
      opacity: 1,
      y: 0
    } : {
      opacity: 0,
      y: 16
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: shouldReduceMotion ? 0 : 0.42,
        ease: [0.2, 0.8, 0.2, 1] as [number, number, number, number]
      }
    }
  };
  return <section data-section-id="30450" id="program-benefits" data-nav="dark" className="bg-background text-foreground py-24 md:py-32">
      <div className="mx-auto w-full max-w-[1440px] px-5 md:px-10">
        {}
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: shouldReduceMotion ? 0 : 0.42,
        ease: [0.2, 0.8, 0.2, 1]
      }} className="mb-16 md:mb-20">
          {}
          <div className="h-[2px] w-full mb-3" style={{
          backgroundColor: "var(--primary)"
        }} aria-hidden="true" />
          <p className="text-xs font-medium uppercase mb-8" style={{
          letterSpacing: "0.18em",
          color: "var(--muted-foreground)"
        }}>
            Why Choose VPNGENIX
          </p>
          <h2 className="font-default font-black uppercase text-foreground" style={{
          fontSize: "clamp(2.5rem, 7vw, 6.5rem)",
          letterSpacing: "-0.015em",
          lineHeight: "0.88"
        }}>
            UNMATCHED
            <br />
            <span className="inline-block relative">
              PRIVACY
              <span aria-hidden="true" className="absolute left-0 right-0 h-[2px]" style={{
              backgroundColor: "var(--primary)",
              bottom: "-6px"
            }} />
            </span>
          </h2>
        </motion.div>

        {}
        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        amount: 0.15
      }} className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-8">
          {perks.map((perk, i) => {
          const Icon = perk.icon;
          return <motion.div data-index={i} key={i} variants={cardVariants} whileHover={shouldReduceMotion ? {} : {
            y: -4,
            transition: {
              duration: 0.22,
              ease: [0.2, 0.8, 0.2, 1]
            }
          }} className="group relative bg-card text-card-foreground rounded-lg p-7 md:p-10 border-2 border-transparent hover:border-primary transition-colors duration-200 shadow-md">
                {}
                <Icon className="w-10 h-10 mb-6 transition-colors duration-200 text-card-foreground group-hover:text-primary" strokeWidth={1.5} aria-hidden="true" />

                {}
                <div className="h-[2px] w-10 mb-5" style={{
              backgroundColor: "var(--primary)"
            }} aria-hidden="true" />

                {}
                <h3 className="font-default font-semibold text-card-foreground mb-4 uppercase" style={{
              fontSize: "clamp(1.5rem, 2.2vw, 2.25rem)",
              letterSpacing: "-0.01em",
              lineHeight: "1.15"
            }}>
                  {perk.title}
                </h3>

                {}
                <p className="font-default" style={{
              fontSize: "1rem",
              lineHeight: "1.55",
              color: "var(--muted-foreground)"
            }}>
                  {perk.description}
                </p>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}